import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/copybook-template',
  component: Layout,
  name: 'CopybookTemplateRoot',
  meta: {
    title: '字帖模板',
    icon: 'i-ant-design:appstore-twotone',
    order: 4,
  },
  children: [
    {
      path: '',
      name: 'CopybookTemplate',
      component: () => import('@/views/copybook/template/index.vue'),
      meta: {
        title: '字帖模板',
        icon: 'i-ant-design:appstore-twotone',
        auth: 'copybook-template:list',
        menu: false,
      },
    },
    {
      path: 'form/:id?',
      name: 'CopybookForm',
      component: () => import('@/views/copybook/form/index.vue'),
      meta: {
        title: '字帖表单',
        auth: 'copybook:list',
        menu: false,
        activeMenu: '/copybook-template',
      },
    },
  ],
}

export default routes
